// extracted by mini-css-extract-plugin
module.exports = {"root":"TravelGuideTeaser_root__pF2SJ","cardBody":"TravelGuideTeaser_cardBody__GllVo","cardTitle":"TravelGuideTeaser_cardTitle__1fEM1"};